export default class TabSectionAccordion {
    constructor(elm, args) {
        var accordion = elm || [];
        if (!accordion) { return; }

        var items = accordion.querySelectorAll('.accordion__item');
        var imageContainers = elm.querySelectorAll('[data-container-id]')

        for (var i = 0; i < items.length; i++) {
            var target = items[i].querySelector('.accordion__toggle');
            target.addEventListener('click', toggleTab);
            target.item = elm;
        }

        function toggleTab(event) {
            var parentItem = this.parentNode;
            var target = parentItem.querySelector('.accordion__item-body');

            const imageContainer = elm.querySelector(`[data-container-id="${parentItem.dataset.containerToggleId}"]`);

            imageContainers.forEach(x => x.classList.add('accordion__image-container--hidden'));
            imageContainer.classList.remove('accordion__image-container--hidden');

            if (parentItem.classList.contains('accordion__item--active')) {
                collapseSection(target);
                parentItem.classList.remove('accordion__item--active');
                return false;
            }

            const button = parentItem.querySelector('.btn--secondary');
            if (button) {
                button.classList.remove('btn--secondary');
                button.classList.remove('btn--wide');
                button.style.marginBottom = 0;
            }

            var item = event.currentTarget.item;
            var active = item.querySelector('.accordion__item--active');

            if (active !== null) {
                var activeTarget = active.querySelector('.accordion__item-body');
                collapseSection(activeTarget);
                active.classList.remove('accordion__item--active');
            }

            parentItem.classList.add('accordion__item--active');
            expandSection(target);
        }

        function collapseSection(element) {
            // get the height of the element's inner content, regardless of its actual size
            var sectionHeight = element.scrollHeight;

            // temporarily disable all css transitions
            var elementTransition = element.style.transition;
            element.style.transition = '';

            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the element's height to its current pixel height, so we 
            // aren't transitioning out of 'auto'
            requestAnimationFrame(function () {
                element.style.height = sectionHeight + 'px';
                element.style.transition = elementTransition;

                // on the next frame (as soon as the previous style change has taken effect),
                // have the element transition to height: 0
                requestAnimationFrame(function () {
                    element.style.height = 0 + 'px';
                });
            });
        }

        function expandSection(element) {
            // get the height of the element's inner content, regardless of its actual size
            var sectionHeight = element.scrollHeight;

            // have the element transition to the height of its inner content
            element.style.height = sectionHeight + 'px';

            // when the next css transition finishes (which should be the one we just triggered)
            const endTransition = () => {
                element.removeEventListener('transitionend', endTransition);
                element.style.height = '';

                if (!element.closest('.accordion__item--active')) {
                    element.style.height = '';
                } else {
                    element.style.height = 'auto';
                }
            };

            element.addEventListener('transitionend', endTransition);
        }

        function isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)

            );
        }

        const extendedSection = elm.querySelector('.accordion__heading');
        var opened = false;
        document.addEventListener('scroll', function () {
            if (isInViewport(extendedSection) && !opened) {
                setTimeout(function () {
                    elm.querySelector('.accordion__toggle').click();
                }, 500);
                opened = true;
            };
        }, {
            passive: true
        });
    }
}


